import React from "react";
import SectionTitle from "../SectionTitle";
import styles from "./CollaboratorsGrid.module.scss";
import { importImages } from "../../utils/helpers";
import Img from "gatsby-image";

const logos = importImages(
	require.context("../../images/collaborators", false, /\.(jpe?g)$/)
);

const CollaboratorsGrid = props => {
	const list = props.list || [];

	const items = list.map((item, i) => {
	
		return (
			<div
				key={i + 1}
				key={"collabGrid-" + i}
				className={"col-6 col-sm-4 text-center " + styles.collaborator}
			>
			<div  className={"img_fill " + styles.image_bg_fill} style={{ backgroundImage: "url(" + item.logo.sizes.src + ")" }} />
				{/* <Img
					title={item.name}
					alt={item.name}
					sizes={item.logo.sizes}
					className="m-md-3 bomba my-3 text-center"
				/> */}
			</div>
		);
	});

	return (
		<div className={"container my-5 " + props.className}>
			<SectionTitle
				title={props.title || "Section Title"}
				style={{ marginBottom: "1.5rem" }}
			/>
			<div className="row justify-content-center align-items-center">
				{items}
			</div>
		</div>
	);
};

export default CollaboratorsGrid;



// WEBPACK FOOTER //
// ./src/components/CollaboratorsGrid/index.js